(function () {
  'use strict';

  // Data de corte: reviews ANTES desta data são importadas (Trustvox).
  // Lê do atributo data-cutoff do script (configurável via snippet).
  var scriptEl = document.getElementById('pl-imported-badge-config');
  var CUTOFF = scriptEl ? scriptEl.getAttribute('data-cutoff') : '2026-07-01';
  var cutoffDate = new Date(CUTOFF + 'T00:00:00');

  var TEXT = 'Verificado';

  // Converte "DD/MM/AAAA" para Date
  function parseBR(str) {
    var m = str.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return null;
    return new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10));
  }

  function processReviews() {
    var reviews = document.querySelectorAll('.jm-review-item');
    if (!reviews.length) return false;

    reviews.forEach(function (rev) {
      // idempotência: já processada?
      if (rev.getAttribute('data-pl-badge-done') === '1') return;

      // já tem selo nativo? marca como done e sai
      if (rev.querySelector('.jm-verified-buyer-badge')) {
        rev.setAttribute('data-pl-badge-done', '1');
        return;
      }

      // acha a data
      var dateEl = null;
      var candidates = rev.querySelectorAll('span.jm-text');
      for (var i = 0; i < candidates.length; i++) {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(candidates[i].textContent.trim())) {
          dateEl = candidates[i];
          break;
        }
      }
      if (!dateEl) return; // sem data, não mexe

      var revDate = parseBR(dateEl.textContent);
      if (!revDate) return;

      // só injeta se for ANTES do corte (importada)
      if (revDate >= cutoffDate) {
        rev.setAttribute('data-pl-badge-done', '1');
        return;
      }
      
      // acha o nome (irmão de onde o selo deve entrar)
      var nameEl = rev.querySelector('.jm-reviewer-info__name');
      if (!nameEl) return;

      // cria o selo idêntico ao nativo
      var badge = document.createElement('div');
      badge.className = 'pl-verified';
      var p = document.createElement('p');
      p.className = 'pl-verified__text';
      p.textContent = TEXT;
      badge.appendChild(p);

      // insere logo depois do nome (mesmo lugar do nativo)
      nameEl.parentNode.insertBefore(badge, nameEl.nextSibling);

      rev.setAttribute('data-pl-badge-done', '1');
    });

    return true;
  }

  function init() {
    // tenta direto
    processReviews();

    // observer pra widget assíncrono + paginação
    var target = document.querySelector('.jdgm-widget, [class*="review-widget"]') || document.body;
    var observer = new MutationObserver(function () {
      processReviews();
    });
    observer.observe(target, { childList: true, subtree: true });

    // fallback: desliga após 15s (paginação usa re-render, mas 15s cobre load inicial)
    // mantemos observer ativo pra paginação — só reduzimos escopo pro widget, não body
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();